/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */

import { DataTable, DataTableColumn as TD, DataTableHeader as TH, DataTableRow as TR, Detail, List, ListRow, ListRowItem, NavigationDrawer } from 'ui-library/dist/external/components'
import { BaseLayout, ListViewLayout } from 'ui-library/dist/external/layouts'
import React from 'react'
import HotelAction from '../../../action/hotel'
import r from '../../../util/Renderer'
import { Link } from 'react-router-dom'
import { dateToStringDate } from '../../../util/DateString'

function ListView(props) {
  const hotels = props.hotels
  const rooms = props.match.params.id ? props.rooms : []
  const toolbar = { label: '宿泊施設管理', items: props.accountMenu }

  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />

      <BaseLayout>
        <ListViewLayout>
          <DataTable
            headers={[
              <TH key={1} width="80%">
                宿泊施設名
              </TH>,
              <TH key={2} width="20%">
                運営終了日
              </TH>
            ]}
            rows={hotels.map((hotel, index) => (
              <TR key={index} onClick={e => HotelAction.showDetailView(hotel)}>
                <TD>{hotel.name}</TD>
                <TD>{dateToStringDate(hotel.closed_date)}</TD>
              </TR>
            ))}
          />
        </ListViewLayout>

        {r.renderIf(props.showDetail)(
          <Detail showFooter primaryButton={{ label: '編集', onClick: e => HotelAction.toEditView(props.match.params.id) }} onDeactivate={e => HotelAction.hideDetailView()}>
            <HotelDetailView rooms={rooms} />
          </Detail>
        )}
      </BaseLayout>
    </React.Fragment>
  )
}

function HotelDetailView(props) {
  return (
    <React.Fragment>
      <List>
        <ListRow>
          <ListRowItem width={'400px'} overline={'部屋数'} primaryText={`${props.rooms.size} 部屋`} />
        </ListRow>
      </List>
      <List>
        {props.rooms.map(room => {
          return (
            <ListRow key={`${room.id}`}>
              <ListRowItem
                width={'400px'}
                overline={
                  <React.Fragment>
                    <Link to={`/setting/${room.id}/info`}>{room.name}</Link>
                  </React.Fragment>
                }
              />
              <ListRowItem width={'400px'} overline={`住所`} primaryText={room.address} />
              <ListRowItem width={'200px'} overline={`チェックイン時間`} primaryText={room.default_check_in} />
              <ListRowItem width={'200px'} overline={`チェックアウト時間`} primaryText={room.default_check_out} />
              <ListRowItem width={'400px'} overline={`鍵番号`} primaryText={room.key_code} />
            </ListRow>
          )
        })}
      </List>
    </React.Fragment>
  )
}

export default ListView
